module.exports = __webpack_public_path__ + "media/img/dowod_rejestracyjny1-c1c46eac.png";